module.exports = ".custom-list-group {\n  height: 220px;\n  overflow-y: scroll; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/enroll/components/enroll-cabinet/tabs/enroll-entrans-info/enroll-entrans-info.component.scss
// module id = ./src/app/modules/enroll/components/enroll-cabinet/tabs/enroll-entrans-info/enroll-entrans-info.component.scss
// module chunks = main